import {
    REALTIME_CONNECTION_CONNECTED,
    REALTIME_CONNECTION_DISCONNECTED,
    REALTIME_CONNECTION_AUTHENTICATING,
    REALTIME_CONNECTION_AUTHENTICATED,

    VALIDATE_REAL_TIME_REQUEST_PARAMS,
    VALIDATE_REAL_TIME_REQUEST_PARAMS_SUCCESS,
    VALIDATE_REAL_TIME_REQUEST_PARAMS_FAILED,

    GET_REAL_TIME_DATA,
    GET_REAL_TIME_DATA_SUCCESS,
    GET_REAL_TIME_DATA_FAILED,
    ALERT_MSG
} from "constants/ActionTypes";

const initial_state = {
    is_connected: false,
    socket: null,
    error: null,
    authorized: false,
    is_authenticated: false,
    is_authenticating: false,

    validate_real_time_request_params_data: {},
    validating_real_time_request_params: false,
    validating_real_time_request_params_success: false,
    validating_real_time_request_params_failed: false,

    real_time_data: {},
    fetching_real_time_data: false,
    fetching_real_time_data_success: false,
    fetching_real_time_data_failed: false,
    alert_msg: ""
};

const realtime_reducer = (state = initial_state, action) => {
    switch (action.type) {
        case REALTIME_CONNECTION_CONNECTED: {
            return {
                ...state,
                socket: action.payload.socket,
                is_connected: true,
                error: null,
                fetching: false
            };
        }
        case REALTIME_CONNECTION_DISCONNECTED: {
            return {
                ...state,
                socket: null,
                is_connected: false,
                error: action.payload.error,
                fetching: false
            };
        }
        case REALTIME_CONNECTION_AUTHENTICATING: {
            return {
                ...state,
                is_authenticated: false,
                is_authenticating: true,
            };
        }
        case REALTIME_CONNECTION_AUTHENTICATED: {
            return {
                ...state,
                is_authenticated: true,
                is_authenticating: false,
                authorized: action.payload.authorized
            };
        }

        case VALIDATE_REAL_TIME_REQUEST_PARAMS: {
            return {
                ...state,
                validating_real_time_request_params: true,
                validating_real_time_request_params_success: false,
                validating_real_time_request_params_failed: false,
                real_time_data: {},
            };
        }

        case VALIDATE_REAL_TIME_REQUEST_PARAMS_SUCCESS: {
            return {
                ...state,
                validating_real_time_request_params: false,
                validating_real_time_request_params_success: true,
                validating_real_time_request_params_failed: false,
                validate_real_time_request_params_data: action.payload,
                real_time_data: {},
            };
        }

        case VALIDATE_REAL_TIME_REQUEST_PARAMS_FAILED: {
            return {
                ...state,
                validating_real_time_request_params: false,
                validating_real_time_request_params_success: false,
                validating_real_time_request_params_failed: true,
                validate_real_time_request_params_data: action.payload,
                real_time_data: {},
            };
        }

        case GET_REAL_TIME_DATA: {
            return {
                ...state,
                fetching_real_time_data: true,
                fetching_real_time_data_success: false,
                fetching_real_time_data_failed: false,
                real_time_data: {},
                validate_real_time_request_params_data: {}
            };
        }

        case GET_REAL_TIME_DATA_SUCCESS: {
            return {
                ...state,
                fetching_real_time_data: false,
                fetching_real_time_data_success: true,
                fetching_real_time_data_failed: false,
                real_time_data: action.payload,
                validate_real_time_request_params_data: {}
            };
        }

        case GET_REAL_TIME_DATA_FAILED: {
            return {
                ...state,
                fetching_real_time_data: false,
                fetching_real_time_data_success: false,
                fetching_real_time_data_failed: true,
                real_time_data: action.payload,
                validate_real_time_request_params_data: {}
            };
        }
        case ALERT_MSG: {
            return {
                ...state,
                alert_msg: action.payload
            }
        }
        
        default:
            return state;
    }
};

export default realtime_reducer;